<template>
    <section class="import-products-index">
        <div class="col-md-12">
            <pim-header header="Import Products"></pim-header>
            <div>
                <product-alerts :status="alert" v-model="alert"></product-alerts>
            </div>

            <transition name="vue-table-loader">
                <div class="vue-table-loader" v-if="isLoading"><span class="fa fa-cog fa-spin fa-3x"></span></div>
            </transition>

            <div class="card panel panel-default">
                <div class="card-block">
                    <form action="">
                        <input type="hidden" name="_token" :value="csrfToken">
                        <div class="row">
                            <div class="col-md-6">
                                <label for="" v-if="languageField.label">
                                    <span class="label-title">{{languageField.label}}</span>
                                    <span v-if="languageField.required" class="required-field">*</span>
                                </label>
                                <input-selectbox v-model="languageField.value" :field-data="languageField"></input-selectbox>
                            </div>
                            <div class="col-md-6">
                                <label for="" v-if="imagesUpdateModeField.label">
                                    <span class="label-title">{{imagesUpdateModeField.label}}</span>
                                    <span v-if="imagesUpdateModeField.required" class="required-field">*</span>
                                </label>
                                <input-selectbox v-model="imagesUpdateModeField.value" :field-data="imagesUpdateModeField"></input-selectbox>
                            </div>
                            <div class="col-md-6">
                                <label for="" v-if="attributeSetsUpdateModeField.label">
                                    <span class="label-title">{{attributeSetsUpdateModeField.label}}</span>
                                    <span v-if="attributeSetsUpdateModeField.required" class="required-field">*</span>
                                </label>
                                <input-selectbox v-model="attributeSetsUpdateModeField.value" :field-data="attributeSetsUpdateModeField"></input-selectbox>
                            </div>
                            <div class="col-md-6">
                                <label for="" v-if="categoriesUpdateModeField.label">
                                    <span class="label-title">{{categoriesUpdateModeField.label}}</span>
                                    <span v-if="categoriesUpdateModeField.required" class="required-field">*</span>
                                </label>
                                <input-selectbox v-model="categoriesUpdateModeField.value" :field-data="categoriesUpdateModeField"></input-selectbox>
                            </div>
                            <div class="col-md-6">
                                <label for="" v-if="channelsUpdateModeField.label">
                                    <span class="label-title">{{channelsUpdateModeField.label}}</span>
                                    <span v-if="channelsUpdateModeField.required" class="required-field">*</span>
                                </label>
                                <input-selectbox v-model="channelsUpdateModeField.value" :field-data="channelsUpdateModeField"></input-selectbox>
                            </div>
                            <div class="col-md-6">
                                <label for="" v-if="tagsUpdateModeField.label">
                                    <span class="label-title">{{tagsUpdateModeField.label}}</span>
                                    <span v-if="tagsUpdateModeField.required" class="required-field">*</span>
                                </label>
                                <input-selectbox v-model="tagsUpdateModeField.value" :field-data="tagsUpdateModeField"></input-selectbox>
                            </div>

                            <div class="col-md-6">
                                <label for="" v-if="clearProductAttributesField.label">
                                    <span class="label-title">{{clearProductAttributesField.label}}</span>
                                    <span v-if="clearProductAttributesField.required" class="required-field">*</span>
                                </label>
                                <input-checkbox v-model="clearProductAttributesField.value" :field-data="clearProductAttributesField"></input-checkbox>
                            </div>
                            <div class="col-md-6">
                                <label for="" v-if="clearProductGenericEntitiesField.label">
                                    <span class="label-title">{{clearProductGenericEntitiesField.label}}</span>
                                    <span v-if="clearProductGenericEntitiesField.required" class="required-field">*</span>
                                </label>
                                <input-checkbox v-model="clearProductGenericEntitiesField.value" :field-data="clearProductGenericEntitiesField"></input-checkbox>
                            </div>
                        </div>

                        <div class="row" v-if="languageField.value">
                            <div class="col-md-12">
                                <div id="importCsvDropzone" class="ext-right border p-3">
                                    <vue-dropzone
                                        v-on:vdropzone-file-added="fileAdded"
                                        v-on:vdropzone-removed-file="fileRemoved"
                                        v-on:vdropzone-sending="fileSending"
                                        v-on:vdropzone-complete="uploadComplete"
                                        v-on:vdropzone-error="uploadFailed"
                                        id="assetDropzone"
                                        acceptedFiles="text/csv"
                                        withCredentials="true"
                                        ref="assetDropzone"
                                        :useCustomSlot=true
                                        :options="dropzoneOptions">
                                        <div class="dropzone-custom-content">
                                            <h3 class="dropzone-custome-title">Drop files here or click to upload</h3>
                                        </div>
                                    </vue-dropzone>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-1" v-if="languageField.value && imagesUpdateModeField.value && attributeSetsUpdateModeField.value && categoriesUpdateModeField.value && channelsUpdateModeField.value && tagsUpdateModeField.value">
                                <button v-on:click="uploadCSV()" type="button" class="btn btn-primary">Import</button>
                            </div>
                            <div class="col-md-4">
                                <a
                                    class="btn btn-warning"
                                    :href="templateRoute"
                                >
                                    <i class="fa fa-file"></i> Download Example CSV Template
                                </a>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </section>
</template>

<script type="text/javascript">
    import Vue from 'vue';
    import VueEvents from 'vue-events';
    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';

    import PimHeader from '../generic/pim-header';
    import InputSelectbox from '../form/form-selectbox.vue';
    import ProductAlerts from '../products/product-details-alerts.vue';
    import InputCheckbox from '../form/form-checkbox.vue';

    Vue.use(VueEvents);

    const updateModeOptions = [{'id': 'replace', 'name': 'REPLACE VALUES'}, {'id': 'add', 'name': 'ADD NEW VALUES'}];

    export default {
        name: 'import-products-index',
        props: ['csrfToken', 'templateRoute', 'uploadRoute'],
        components: {
            'pim-header': PimHeader,
            'input-selectbox': InputSelectbox,
            'product-alerts': ProductAlerts,
            vueDropzone: vue2Dropzone,
            'input-checkbox': InputCheckbox
        },
        data() {
            return {
                languageField: {
                    label: 'First, select the Language you are about to import products to',
                    required: true,
                    disabled: false,
                    type: 'select',
                    name: 'selectedLanguage',
                    value: '',
                    options: dataObject.languages
                },
                imagesUpdateModeField: {
                    label: 'If the CSV has images, how do you want to update that?',
                    required: true,
                    disabled: false,
                    type: 'select',
                    name: 'imagesUpdateMode',
                    value: '',
                    options: updateModeOptions
                },
                attributeSetsUpdateModeField: {
                    label: 'If the CSV has attribute sets, how do you want to update that?',
                    required: true,
                    disabled: false,
                    type: 'select',
                    name: 'attributeSetsUpdateMode',
                    value: '',
                    options: updateModeOptions
                },
                categoriesUpdateModeField: {
                    label: 'If the CSV has categories, how do you want to update that?',
                    required: true,
                    disabled: false,
                    type: 'select',
                    name: 'categoriesUpdateMode',
                    value: '',
                    options: updateModeOptions
                },
                channelsUpdateModeField: {
                    label: 'If the CSV has channels, how do you want to update that?',
                    required: true,
                    disabled: false,
                    type: 'select',
                    name: 'channelsUpdateMode',
                    value: '',
                    options: updateModeOptions
                },
                tagsUpdateModeField: {
                    label: 'If the CSV has tags, how do you want to update that?',
                    required: true,
                    disabled: false,
                    type: 'select',
                    name: 'tagsUpdateMode',
                    value: '',
                    options: updateModeOptions
                },
                clearProductAttributesField: {
                    label: 'Clear product\'s attributes if value is empty',
                    required: false,
                    disabled: false,
                    name: 'clearProductAttributesCheckbox',
                    value: false
                },
                clearProductGenericEntitiesField: {
                    label: 'Clear product\'s generic entities if value is empty',
                    required: false,
                    disabled: false,
                    name: 'clearProductGenericEntitiesCheckbox',
                    value: false
                },
                hasFile: false,
                isLoading: false,
                alert: {
                    message: "",
                    status: "alert-success",
                    timeOut: 15000,
                },
                dropzoneOptions: {
                    addRemoveLinks: true,
                    url: this.uploadRoute,
                    thumbnailWidth: 150,
                    headers: {'X-CSRF-Token': this.csrfToken},
                    maxFiles: 1,
                    autoProcessQueue: false
                }
            }
        },
        methods: {
            fileAdded: function(file) {
                this.hasFile = true;
            },
            fileRemoved: function (file, error, xhr) {
                this.hasFile = false;
            },
            fileSending: function (file, xhr, formData) {
                formData.append('languageId', this.languageField.value);
                formData.append('clearProductAttributes', this.clearProductAttributesField.value);
                formData.append('clearProductGenericEntities', this.clearProductGenericEntitiesField.value);
                formData.append('attributeSetsUpdateMode', this.attributeSetsUpdateModeField.value);
                formData.append('categoriesUpdateMode', this.categoriesUpdateModeField.value);
                formData.append('channelsUpdateMode', this.channelsUpdateModeField.value);
                formData.append('imagesUpdateMode', this.imagesUpdateModeField.value);
                formData.append('tagsUpdateMode', this.tagsUpdateModeField.value);
            },
            uploadComplete: function (response) {
                this.isLoading = false;
                
                if (response.xhr.status == 200) {
                    this.hasFile = false;
                    this.alert.status = "alert-success";
                    this.alert.message = 'Success, import initiated, we are redirecting you to the Jobs page.';
                    this.$refs.assetDropzone.removeAllFiles();
                    setTimeout(function() {
                        window.location = "/jobs";
                    }, 2000);
                } else {
                    this.alert.status = "alert-danger";
                    this.alert.message = response.xhr.responseText || 'There was an error, please try again later.';
                }
            },
            uploadFailed: function (file, message, xhr) {
                this.isLoading = false;
                this.alert.status = "alert-danger";
                this.alert.message = xhr.responseText || 'There was an error, please try again later.';
            },
            uploadCSV() {
                if (!this.hasFile) {
                    this.alert.status = "alert-danger";
                    this.alert.message = 'Please select or "drag and drop" a file.';
                    return;
                }

                if (!this.languageField.value) {
                    this.alert.status = "alert-danger";
                    this.alert.message = 'Please select the Language you are importing products to.';
                    return;
                }

                this.isLoading = true;
                this.$refs.assetDropzone.processQueue();
            }
        }
    };
</script>

<style>
    #importCsvDropzone > .vue-dropzone > .dz-preview > .dz-progress {
        display: none;
    }
</style>